import { lazy, Suspense } from "react";
import Loader from "../custom/loader/main";

const Main = lazy(
  () => import("../components/approval/sessionSummaryResult/main"),
);

const SessionSummaryResult = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Main />
    </Suspense>
  );
};

export default SessionSummaryResult;
